const {registerModule} = window;

/**
 * Hero module
 */
class Hero {
  constructor(element) {
    this.element = element;
    this.initialize();
  }

  initialize() {
    this.bindUI();
    this.setVars();

    if (this.matchMediaTouchscreen || this.isSafari) {
      // if touchscreen device (or if desktop Safari), gradient moves automatically
      const _this = this; // needed to access within setInterval
      this.ui.$gradientOne.style['transition-timing-function'] = 'linear';
      if (this.ui.$gradientTwo) {
        this.ui.$gradientTwo.style['transition-timing-function'] = 'linear';
      }

      setInterval(function() {
        _this.loopPosition = (_this.loopPosition + 1) % _this.loopPath.length;
        const [newX, newY] = _this.loopPath[_this.loopPosition];

        const centeredOffsets = { // used for the 0,0 position; everything else is transformed relative to the center
          x: (_this.element.offsetWidth - _this.ui.$gradientOne.offsetWidth) / 2,
          y: (_this.element.offsetHeight - _this.ui.$gradientOne.offsetHeight) / 2,
        };

        _this.ui.$gradientOne.style.transform = `translate(calc(${centeredOffsets.x + (_this.element.offsetWidth * newX)}px), calc(${centeredOffsets.y + (_this.element.offsetHeight * newY)}px)`;
        if (_this.ui.$gradientTwo) {
          _this.ui.$gradientTwo.style.transform = `translate(calc(${centeredOffsets.x + (_this.element.offsetWidth * newX * -1)}px), calc(${centeredOffsets.y + (_this.element.offsetHeight * newY * -1)}px)`;
        }
      }, this.loopDuration / this.loopPath.length);
    } else {
      // if not touchscreen device, gradient follows mouse movement
      const updateGradientPositions = () => {
        this.ui.$gradientOne.style.transform = `translate3d(calc(${this.mousePosition.x}px - 50%), calc(${this.mousePosition.y}px - 50%), 0)`;
        if (this.ui.$gradientTwo) {
          this.ui.$gradientTwo.style.transform = `translate3d(calc(${this.element.offsetWidth}px - ${this.mousePosition.x}px - 50%), calc(${this.element.offsetHeight}px - ${this.mousePosition.y}px - 50%), 0)`;
        }
        requestAnimationFrame(updateGradientPositions);
      };

      document.addEventListener('mousemove', (e) => {
        this.mousePosition.x = e.clientX;
        this.mousePosition.y = e.clientY;
      });

      requestAnimationFrame(updateGradientPositions);
    }
  }

  bindUI() {
    this.ui = {};
    const [gradientOne, gradientTwo] = this.element.querySelectorAll('.hero__gradient--circle');
    this.ui.$gradientOne = gradientOne;
    this.ui.$gradientTwo = gradientTwo;
  }

  getCoordinates(degree, side) {
    const rad = degree * Math.PI / 180;
    const xBase = Math.cos(rad);
    const xScaled = side === 'left' ? (xBase - 1) / 4 : (xBase + 1) / 4;
    const yBase = Math.sin(rad);
    const yScaled = yBase / 2;
    return [xScaled, yScaled];
  }

  setVars() {
    this.matchMediaTouchscreen = window.matchMedia('(pointer: coarse)').matches;
    this.isSafari = navigator.userAgent.toLowerCase().indexOf('safari') > -1 && navigator.userAgent.toLowerCase().indexOf('chrome') === -1;
    this.loopPath = [
      this.getCoordinates(240, 'left'),
      this.getCoordinates(260, 'left'),
      this.getCoordinates(280, 'left'),
      this.getCoordinates(300, 'left'),
      this.getCoordinates(320, 'left'),
      this.getCoordinates(340, 'left'),
      this.getCoordinates(0, 'left'), // equivalent to 180 right
      this.getCoordinates(160, 'right'),
      this.getCoordinates(140, 'right'),
      this.getCoordinates(120, 'right'),
      this.getCoordinates(100, 'right'),
      this.getCoordinates(80, 'right'),
      this.getCoordinates(60, 'right'),
      this.getCoordinates(40, 'right'),
      this.getCoordinates(20, 'right'),
      this.getCoordinates(0, 'right'),
      this.getCoordinates(340, 'right'),
      this.getCoordinates(320, 'right'),
      this.getCoordinates(300, 'right'),
      this.getCoordinates(280, 'right'),
      this.getCoordinates(260, 'right'),
      this.getCoordinates(240, 'right'),
      this.getCoordinates(220, 'right'),
      this.getCoordinates(200, 'right'),
      this.getCoordinates(0, 'left'), // equivalent to 180 right
      this.getCoordinates(20, 'left'),
      this.getCoordinates(40, 'left'),
      this.getCoordinates(60, 'left'),
      this.getCoordinates(80, 'left'),
      this.getCoordinates(100, 'left'),
      this.getCoordinates(120, 'left'),
      this.getCoordinates(140, 'left'),
      this.getCoordinates(160, 'left'),
      this.getCoordinates(180, 'left'),
      this.getCoordinates(200, 'left'),
      this.getCoordinates(220, 'left'),
    ];

    this.loopPosition = 0; // starting position for the loop;
    this.loopDuration = 15000; // duration of entire loop, split evenly between loopPath elements
    this.mousePosition = {x: undefined, y: undefined};
  }
}

registerModule('Hero', Hero);
